import React from 'react';
import { ArrowLeft, Edit } from 'lucide-react';

const AdminBookingHeader = ({ 
  onBack, 
  status, 
  statusColor, 
  statusText, 
  onUpdateStatus 
}) => {
  const isCompleted = status === 'completed';
  
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3">
      <button
        onClick={onBack}
        className="inline-flex items-center text-black hover:text-gray-600 transition-colors text-xs sm:text-sm md:text-base w-fit"
      >
        <ArrowLeft className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2 flex-shrink-0" />
        <span className="truncate">Back to Bookings</span>
      </button>
      <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
        <span className={`inline-flex items-center px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs sm:text-sm font-medium ${statusColor} whitespace-nowrap`}>
          {statusText}
        </span>
        {!isCompleted && (
          <button
            onClick={onUpdateStatus}
            className="inline-flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-0.5 sm:py-1 bg-black text-white rounded-lg hover:bg-gray-900 transition-colors text-xs sm:text-sm font-medium whitespace-nowrap"
          >
            <Edit className="w-3 h-3 sm:w-3.5 sm:h-3.5 flex-shrink-0" />
            <span className="hidden xs:inline">Cancel</span>
            <span className="xs:hidden">Cancel</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default AdminBookingHeader;

